<template>
  <div class="flex items-center btn-group-border">
    <div
      class="tooltip"
      data-tip="Download firmware configuration file in JSON format"
    >
      <button
        @click="downloadJSON"
        class="btn btn-neutral btn-group-start"
        :disabled="backend.currentConfig == null"
      >
        <Icon icon="ic:baseline-download" class="text-lg" />
      </button>
    </div>

    <div
      class="tooltip"
      data-tip="Load firmware configuration from uploaded JSON file"
    >
      <FileUpload
        class="btn-group-end"
        accept="application/json"
        method="readAsText"
        :disabled="backend.currentConfig == null"
        @loaded="uploadJSON"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useToast } from "vue-toastification";
import { useBackendStore, useKeyboardStore } from "@/stores";
import FileUpload from "@/components/utils/FileUpload.vue";

const toast = useToast();
const backend = useBackendStore();
const kb = useKeyboardStore();

const formatDateTime = (d: Date) => {
  const d2 = (num: number) =>
    num.toString().length == 1 ? "0" + num.toString() : num.toString();
  const date = `${d.getFullYear()}${d2(d.getMonth() + 1)}${d2(d.getDate())}`;
  const time = `${d2(d.getHours())}${d2(d.getMinutes())}${d2(d.getSeconds())}`;
  return `${date}_${time}`;
};

const downloadJSON = () => {
  const final = backend.currentConfigFinal;
  if (final == null) return;

  // Prepare data
  const data = final.config;
  const uri =
    "data:application/json;charset=utf-8," +
    encodeURIComponent(JSON.stringify(data));
  const fileName =
    [
      final.name,
      ...(backend.configModified ? ["modified"] : []),
      formatDateTime(new Date(Date.now())),
    ].join("__") + ".json";
  // Create virtual hyperlink
  const anchor = document.createElement("a");
  anchor.setAttribute("href", uri);
  anchor.setAttribute("download", fileName);
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
};

const uploadJSON = (file: File, data: ArrayBuffer | string) => {
  kb.setConfig(JSON.parse(data as string));
  if (backend.currentConfig != null) backend.currentConfig.name = file.name;
  toast.success("Loaded configuration from file");
};
</script>
